common.View.create('galaxy::habitats.website.layouts.main.Fixed', {

    openPopup: true,

    onDOMLoad()
    {
        this.initPopup();
    },

    async initPopup()
    {
        await $.ajax({ url: '/has-closed-notification' }).done((data) => { this.openPopup = data.accepted; });

        this.showPopup();

        let image = this.element.find('.image').get(0);
        this.element.find('.popup').click((e) => {
            if(e.target === image) {
                return;
            }

            $.ajax({ url: '/close-notification' });
            this.openPopup = false;

            this.showPopup();
        });
    },

    showPopup()
    {
        if( this.openPopup ) {
            this.element.find('.popup').fadeIn('fast');
        } else {
            this.element.find('.popup').fadeOut('fast');
        }
        // this.element.find('.popup').fadeToggle(this.openPopup);
    }

});
